<div class="row" *ngIf="asset">
    <div class="col-1">&nbsp;</div>
    <div class="col-10 p-3">

        <div class="row">
            <div class="col-12"><h2>{{asset.name}}</h2></div>
        </div>
        <div class="row p-1 banding">
            <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.assets.dashboard.fieldTitles.name' | translate }}</h5></div>
            <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12">{{asset.name}}</div>
        </div>
        <div class="row p-1 banding">
            <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.assets.dashboard.fieldTitles.serialNumber' | translate }}</h5></div>
            <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12">{{asset.serialNumber}}</div>
        </div>
        <div class="row p-1 banding">
            <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.assets.dashboard.fieldTitles.vendor' | translate }}</h5></div>
            <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12">{{asset.vendor}}</div>
        </div>
<!--         <div class="row p-1 banding">
            <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.generic.type' | translate }}</h5></div>
            <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12">{{asset.Type}}</div>
        </div>
        <div class="row p-1">
            <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.assets.dashboard.fieldTitles.status' | translate }}</h5></div>
            <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12">{{asset.status}}</div>
        </div>
 -->
        <div class="row" *ngIf="entitlementsLoaded">
            <div class="col-12"><h4>Entitlements</h4></div>
        </div>

        <div *ngIf="entitlementsLoaded">
            <div class="row faketableheaderrow">
                <div class="col-4 faketableheader">{{ 'pages.assets.dashboard.fieldTitles.name' | translate }}</div>
                <div class="col-4 faketableheader">{{ 'pages.assets.dashboard.fieldTitles.startDate' | translate }}</div>
                <div class="col-4 faketableheader">{{ 'pages.assets.dashboard.fieldTitles.endDate' | translate }}</div>
            </div>

            <div class="row" *ngFor="let ent of asset.entitlements">
                <div class="col-4 faketablecell">{{ent.serviceName || ent.name}}</div>
                <div class="col-4 faketablecell">{{ent.startDate | date: 'dd/MM/yyyy'}}</div>
                <div class="col-4 faketablecell">{{ent.endDate | date: 'dd/MM/yyyy'}}</div>
            </div>

        </div>

 
    </div>
    <div class="col-1">&nbsp;</div>
</div>

<div class="row" *ngIf="asset">
    <div class="col-12">

        <div class="row pt-1">
            <div class="col-12 justify-content-right">
                <fa-icon [icon]="['fas', 'th-list']" size="2x" class="p-1" (click)="changeViewType('list')"></fa-icon>
                <fa-icon [icon]="['fas', 'th-large']" size="2x" class="p-1" (click)="changeViewType('grid')"></fa-icon>
            </div>
        </div>
        
        <ul class="nav nav-tabs">
            <li class="nav-item">
                <a class="nav-link" [ngClass]="{ 'active' : page === 'cases' }" (click)="page = 'cases'; loadCases();">{{ 'pages.support.dashboard.cases' | translate }}</a>
            </li> 
        </ul>
        
        <br/><br/>

        <div class="card-body p-t-1 p-3" *ngIf="viewType === 'list' && (page === 'cases' || page === 'flagged')">
            <app-support-list [cases]="subsetCases" [flagRefs]="flagRefs" [flaggingRef]="flaggingRef" [loaded]="casesLoaded" (flagEmitter)="flag($event);" (sortEmitter)="sortResults($event);"></app-support-list>
        </div>
        
        <div class="card-body p-t-1 p-3" *ngIf="viewType === 'grid' && (page === 'cases' || page === 'flagged')">
            <app-support-grid [cases]="subsetCases" [flagRefs]="flagRefs" [flaggingRef]="flaggingRef" [loaded]="casesLoaded" (flagEmitter)="flag($event);"></app-support-grid>
        </div>
        
        <div class="card-body justify-content-center p-t-1 p-3" *ngIf="(page === 'cases' || page === 'flagged') && casesLoaded">
            <ngb-pagination [collectionSize]="cases.length" pageSize="{{perPage}}" page="currentPage" [(page)]="currentPage" [maxSize]="10" aria-label="Pagination" (pageChange)="onPageChange($event)">
                <ng-template ngbPaginationPrevious></ng-template>
                <ng-template ngbPaginationNext></ng-template>
            </ngb-pagination>
        </div>

    </div>
</div>



